export const works = [
  {
    id: "chaoxi-zhijian",
    title: "潮汐之间",
    type: "电影",
    year: 2026,
    status: "即将上线",
    releaseDate: "2026-12-24",
    duration: "118分钟",
    rating: 8.7,
    heat: 98,
    director: "陈叙",
    cast: ["吴梦梦", "林亦舟", "周砚"],
    tags: ["剧情", "爱情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20an%20elegant%20East%20Asian%20actress%20in%20a%20cream%20trench%20coat%20standing%20on%20a%20foggy%20seaside%20pier%20at%20dawn%2C%20deep%20navy%20blue%20sea%20and%20warm%20orange%20sunrise%20glow%2C%20soft%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-01&orientation=portrait",
    synopsis:
      "一座被潮水反复改写的海边小城，两个在错位时间里相遇的人。吴梦梦在片中一人分饰母女两角，用同一张脸演出两种截然不同的命运：母亲把秘密留在旧灯塔里，女儿在二十年后循着潮声找回来。影片以四季潮汐为章节，把一段关于告别的故事讲得克制而绵长。",
    featured: true,
  },
  {
    id: "anxiang-huisheng",
    title: "暗巷回声",
    type: "电影",
    year: 2025,
    status: "已上映",
    releaseDate: "2025-10-17",
    duration: "126分钟",
    rating: 8.9,
    heat: 95,
    director: "郑北",
    cast: ["吴梦梦", "韩束", "李知遥"],
    tags: ["悬疑", "犯罪"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20woman%20in%20a%20dark%20coat%20walking%20through%20a%20narrow%20rain-soaked%20alley%20at%20night%2C%20deep%20navy%20shadows%20with%20a%20single%20warm%20orange%20street%20lamp%2C%20moody%20thriller%20atmosphere%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-02&orientation=portrait",
    synopsis:
      "一桩十年前结案的旧案，因为一段被修复的录音重新翻开。吴梦梦饰演的声音分析师必须在嘈杂的电流里，辨认出那个被所有人忽略的名字。影片几乎全部发生在夜间，用声音而非画面制造压迫感，是近年少见的听觉型悬疑片。",
    featured: true,
  },
  {
    id: "changye-jiangming",
    title: "长夜将明",
    type: "电视剧",
    year: 2026,
    status: "拍摄中",
    releaseDate: "2026-09-01",
    duration: "45分钟/集",
    rating: 9.1,
    heat: 92,
    director: "许岸",
    cast: ["吴梦梦", "顾南", "白榆"],
    tags: ["年代", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%201930s%20period%20clothing%20standing%20in%20a%20dim%20industrial%20hall%2C%20warm%20orange%20lamp%20light%20cutting%20through%20deep%20navy%20shadows%2C%20smoke%20and%20film%20grain%2C%20restrained%20period%20drama%20mood%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-03&orientation=portrait",
    synopsis:
      "上世纪三十年代的江南丝厂，一名年轻女会计在账本里发现了整座城市的秘密。吴梦梦饰演的女主角从只想守住一份工作，到成为工人们唯一敢相信的那支笔。剧集正在拍摄中，预计明年登陆荧屏。",
    featured: true,
  },
  {
    id: "nanfeng-zhiwoyi",
    title: "南风知我意",
    type: "电视剧",
    year: 2025,
    status: "已上映",
    releaseDate: "2025-05-20",
    duration: "40集",
    rating: 8.4,
    heat: 88,
    director: "林知夏",
    cast: ["吴梦梦", "程野", "苏禾"],
    tags: ["都市", "爱情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%20a%20light%20knit%20sweater%20leaning%20on%20a%20city%20balcony%20at%20golden%20hour%2C%20soft%20warm%20orange%20sky%20over%20deep%20navy%20rooftops%2C%20gentle%20romantic%20urban%20drama%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-04&orientation=portrait",
    synopsis:
      "在南方的雨季里，一位气象预报员和一位旧书店主共用一扇窗。吴梦梦饰演的女主角习惯用数据预测一切，却始终算不准自己的心。四十集的故事没有大起大落，只有一场又一场认真的对话。",
    featured: false,
  },
  {
    id: "diqi-ge-qingchen",
    title: "第七个清晨",
    type: "电影",
    year: 2025,
    status: "已上映",
    releaseDate: "2025-03-08",
    duration: "112分钟",
    rating: 8.6,
    heat: 84,
    director: "陆青",
    cast: ["吴梦梦", "陈屿", "林鹿"],
    tags: ["文艺", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20sitting%20alone%20by%20a%20wide%20window%20in%20early%20morning%20light%2C%20muted%20deep%20navy%20interior%20with%20warm%20orange%20sunrise%20stripes%20across%20the%20floor%2C%20quiet%20arthouse%20drama%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-05&orientation=portrait",
    synopsis:
      "一个连续的七天，一个女人在同一个清晨醒来，屋子里的东西每天少一件。她开始记录，开始在失去里重新认识自己拥有过什么。吴梦梦以极简的表演完成了整部电影，被评论称为「一次安静的深呼吸」。",
    featured: false,
  },
  {
    id: "shanhai-youju",
    title: "山海邮局",
    type: "电影",
    year: 2024,
    status: "已上映",
    releaseDate: "2024-11-11",
    duration: "104分钟",
    rating: 8.2,
    heat: 76,
    director: "潘远",
    cast: ["吴梦梦", "周砚", "阿岩"],
    tags: ["奇幻", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%20a%20wool%20coat%20standing%20beside%20a%20small%20coastal%20post%20office%20at%20dusk%2C%20deep%20navy%20ocean%20and%20warm%20orange%20lantern%20glow%2C%20gentle%20magical%20realism%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-06&orientation=portrait",
    synopsis:
      "海边有一间只在雾天开门的邮局，专门投递那些寄不出去的信。吴梦梦饰演的邮差负责把信送到收信人梦里。一部关于遗憾与和解的奇幻小品，用最朴素的方式讲了一个最动人的道理：有些话晚一点说，也算说到了。",
    featured: false,
  },
  {
    id: "juzi-qishui",
    title: "橘子汽水",
    type: "电视剧",
    year: 2024,
    status: "已上映",
    releaseDate: "2024-07-18",
    duration: "24集",
    rating: 8.0,
    heat: 72,
    director: "苏梨",
    cast: ["吴梦梦", "沈迟", "夏竹"],
    tags: ["青春", "校园"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20young%20woman%20in%20a%20school%20uniform%20holding%20a%20glass%20bottle%20of%20orange%20soda%20on%20a%20sunny%20campus%20path%2C%20warm%20orange%20highlights%20over%20soft%20navy%20shadows%2C%20nostalgic%20youth%20drama%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-07&orientation=portrait",
    synopsis:
      "一所县城中学，一瓶传着喝的橘子汽水，和一群不知道怎么告别的人。吴梦梦回到家乡拍摄这部青春剧，把方言、旧校服和夏天的风都留在了镜头里。",
    featured: false,
  },
  {
    id: "guitu-lieche",
    title: "归途列车",
    type: "电影",
    year: 2024,
    status: "已上映",
    releaseDate: "2024-04-02",
    duration: "121分钟",
    rating: 8.5,
    heat: 79,
    director: "郝明",
    cast: ["吴梦梦", "韩束", "马远"],
    tags: ["公路", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20looking%20out%20of%20a%20night%20train%20window%2C%20warm%20orange%20interior%20light%20reflected%20on%20glass%20over%20deep%20navy%20darkness%20outside%2C%20intimate%20road%20movie%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-08&orientation=portrait",
    synopsis:
      "一列横穿三个省份的绿皮火车上，六个陌生人被同一场暴雨留在车厢里。吴梦梦饰演的列车员是唯一知道这趟车即将停运的人。全片在真实的列车上拍摄，几乎只用自然光。",
    featured: false,
  },
  {
    id: "wusheng-zhengyan",
    title: "无声证词",
    type: "电视剧",
    year: 2023,
    status: "已上映",
    releaseDate: "2023-11-06",
    duration: "32集",
    rating: 8.8,
    heat: 90,
    director: "秦朗",
    cast: ["吴梦梦", "程野", "秦川"],
    tags: ["悬疑", "律政"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%20a%20tailored%20suit%20standing%20in%20an%20empty%20courtroom%20corridor%2C%20cold%20deep%20navy%20light%20with%20one%20warm%20orange%20exit%20sign%20glow%2C%20tense%20legal%20thriller%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-09&orientation=portrait",
    synopsis:
      "她是法庭上唯一听得见手语的人。一桩没有证人、没有录音、只有监控死角里的一个手势的案件，让一位年轻的法律援助律师开始了长达两年的追问。吴梦梦为角色学习了六个月手语。",
    featured: false,
  },
  {
    id: "bailu-weixi",
    title: "白露未晞",
    type: "电影",
    year: 2023,
    status: "已上映",
    releaseDate: "2023-08-22",
    duration: "133分钟",
    rating: 8.3,
    heat: 70,
    director: "顾清和",
    cast: ["吴梦梦", "裴之", "顾南"],
    tags: ["古装", "爱情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%20flowing%20ancient%20Chinese%20hanfu%20standing%20under%20falling%20white%20dew%20mist%2C%20deep%20navy%20blue%20mountains%20and%20warm%20orange%20paper%20lanterns%2C%20poetic%20costume%20drama%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-10&orientation=portrait",
    synopsis:
      "白露那天的约定，她用了一生去等。一部关于等待的古装电影，却在所有细节里讲的是自由。服化道以宋代美学为参考，取景跨越三座古镇。",
    featured: false,
  },
  {
    id: "chengshi-bianyuan",
    title: "城市边缘",
    type: "电影",
    year: 2022,
    status: "已上映",
    releaseDate: "2022-12-09",
    duration: "109分钟",
    rating: 8.1,
    heat: 64,
    director: "罗宇",
    cast: ["吴梦梦", "马远", "阿岩"],
    tags: ["现实", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%20a%20plain%20jacket%20standing%20on%20a%20city%20overpass%20at%20blue%20hour%2C%20deep%20navy%20skyline%20with%20scattered%20warm%20orange%20window%20lights%2C%20social%20realist%20drama%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-11&orientation=portrait",
    synopsis:
      "在一座不断向外扩张的城市里，有一群人住在明天就要拆掉的房子里。吴梦梦饰演的社区工作者，是唯一还在挨家挨户敲门的人。影片用大量非职业演员，记录了一种正在消失的生活。",
    featured: false,
  },
  {
    id: "xueluo-changan",
    title: "雪落长安",
    type: "电视剧",
    year: 2022,
    status: "已上映",
    releaseDate: "2022-06-15",
    duration: "48集",
    rating: 8.7,
    heat: 86,
    director: "沈拓",
    cast: ["吴梦梦", "裴之", "白榆"],
    tags: ["古装", "权谋"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20in%20dark%20embroidered%20ancient%20Chinese%20robes%20standing%20in%20a%20snow%20covered%20palace%20courtyard%2C%20deep%20navy%20night%20sky%20and%20warm%20orange%20lantern%20glow%2C%20epic%20historical%20drama%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=work-12&orientation=portrait",
    synopsis:
      "一场大雪覆盖了整座长安城，也覆盖了一场没有硝烟的夺权。吴梦梦饰演的女官从掌灯的小吏一路走到御前，靠的不是心机，而是她记得每一个人的名字。",
    featured: false,
  },
];

export const yearOptions = ["全部年份", "2026", "2025", "2024", "2023", "2022"];